import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "nes-container with-title mb-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Welcome to Gem Bank"),
  /*#__PURE__*/_createElementVNode("p", null, " This app is designed to illustrate the functionality of Gem Bank. It is not production grade. Use at your own risk. ")
], -1)
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "nes-container with-title flex-1 mr-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Start/manage a bank", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " Choose this if you want to be able to create / lock / unlock vaults for vault owners. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "nes-btn is-primary" }, "Start a bank", -1)
const _hoisted_7 = { class: "nes-container with-title flex-1 ml-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Use your Vault", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " Choose this if you'd like to use a vault opened with someone's bank. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", { class: "nes-btn is-primary" }, "Use vault", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_router_link, { to: "bank" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createVNode(_component_router_link, { to: "vault" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}